<template>
  <el-container id="recibosAvaluos" style="justify-content: center; align-items: center;">
    <el-col
      class="main-wrapper"
      :xs="22"
      :sm="18"
      :md="16"
      :lg="14"
      :xl="12"
    >
      <el-row
        type="flex"
        justify="center"
      >
        <router-link
          to="/busqueda-del-predio"
          v-if="tipo !== 'avaluos'"
        >
          <el-button>
            Consultar otra cuenta
          </el-button>
        </router-link>
      </el-row>
      <br>
      <h3
        style="color: #000000;
        font-size: 16pt;
        line-height: 26px;
        font-weight: bold;
        font-family: 'HelveticaNeue' !important;
        font-weight: bold !important;"
      >
        Recibos
      </h3>
      <br>
      <div class="list-container">
        <ul>
          <li v-for="receipt in receipts" :key="receipt.curt">
            <el-row
              type="flex"
              align="middle"
            >
              <!-- justify="space-around" -->
              <i class="el-icon-office-building" />
              <div class="col-on-xs" style="margin-right: auto">
                <span style="margin: 0 3px 0 15px">
                  Identificador:
                </span>
                <span>
                  {{ `${receipt.cuenta_predial.length === 10 ?
                    `${receipt.recibo.pk} - ${receipt.cuenta_predial}`
                    : receipt.cuenta_predial
                  }` }}
                </span>
                <span>
                  {{ `${receipt.recibo.pk} - ${receipt.cuenta_predial}` }}
                </span>
              </div>
              <el-button
                type="primary"
                class="preview-btn"
                @click="preview(receipt)"
              >
                <i class="el-icon-view" />
              </el-button>
            </el-row>
          </li>
        </ul>
      </div>
      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
        fullscreen
        :show-close="false"
        destroy-on-close
      >
        <template slot="title">
          <el-row
            class="hide-on-print"
            type="flex" align="center"
            justify="space-between"
          >
            <span>
              Recibo
            </span>
            <el-button @click="handleClose">
              <i class="el-icon-back" />
              Regresar
            </el-button>
          </el-row>
        </template>
        <recibo :receipt="selectedReceipt" tipo="avaluos" />
      </el-dialog>
    </el-col>
  </el-container>
</template>

<script>
import Recibo from '@/components/Recibo';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      selectedReceipt: null,
      dialogVisible: false,
    };
  },
  components: {
    Recibo,
  },
  computed: {
    ...mapState({
      receipts: (state) => state.avaluos.receipts,
    }),
  },
  methods: {
    preview(receipt) {
      this.selectedReceipt = receipt;
      this.dialogVisible = true;
    },
    handleClose() {
      this.selectedReceipt = null;
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  background-color: #956FA8;
  color: #FFFFFF;
  font-weight: bold;
}
.list-container {
  ul {
    list-style-type: none;
    li {
      padding: 15px;
      position: relative;
      border-radius: 5px;
      margin-bottom: 15px;
      border: 1px solid #cecece !important;
      font-size: 16px;
      line-height: 30px;
      font-weight: 600;
      i.el-icon-office-building {
        font-size: 20px;
        margin-right: 5px;
        color: #FFFFFF;
        background-color: #B9A5CB;
        border-radius: 50%;
        padding: 5px;
      }
      *:not(i) {
        font-family: 'HelveticaNeue' !important;
      }
      .preview-btn {
        margin: 0;
        margin-left: auto;
        padding: 0;
        padding-right: 15px;
        background: transparent;
        border: none;
        margin-left: 10px;
      }
    }
  }
}
.el-icon-view {
  font-size: 16px;
  color: #B9A5CB;
  font-weight: bold;
}
.col-on-xs {
  span:nth-child(2) {
    max-width: calc(100vw - 150px);
    overflow: hidden;
    text-overflow: ellipsis;
    // overflow-wrap: break-word;
  }
  span:nth-child(2) {
    display: none;
  }
}
</style>

<style lang="scss">
@media only screen and (max-width: 550px) {
  .hideOnXs {
    display: none;
  }
  .col-on-xs {
    display: flex;
    flex-direction: column;
    span:nth-child(2) {
      display: unset !important;
    }
    span:nth-child(3) {
      display: none !important;
    }
  }
}
</style>
